<div class="container">
  <div class="app-loading" *ngIf="appLoading">
    <div class="logo">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
      </svg>
    </div>
    <span>Caricamento...</span>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h1 rtl class="main-heading">Documenti</h1>
    </div>
  </div>
  <div *ngIf="documenti.length === 0">
    <div class="row d-flex justify-content-center" [ngClass]="routeAnimationsElements">
      <p><img src="assets/cupido.png"/></p>
    </div>
    <div class="row d-flex justify-content-center" [ngClass]="routeAnimationsElements">
      <p>Nessun documento presente su questa pratica.</p>
    </div>
  </div>
<div class="row" *ngIf="documenti.length !== 0">
    <div class="col">
      <mat-card *ngFor="let documento of documenti" [ngClass]="routeAnimationsElements">
        <mat-card-title>{{ documento.descrizione }}</mat-card-title>
          <mat-card-actions>
            <button mat-stroked-button color="primary" (click)="downloadDocumento(documento)" *ngIf="documento.codice" ><mat-icon>visibility</mat-icon></button>
            <button mat-stroked-button color="accent" (click)="openBottomSheetUploadDocumento(documento.tipo)" *ngIf="!documento.codice">
              <mat-icon>upload</mat-icon>
            </button>
          </mat-card-actions>
        </mat-card>
    </div>
  </div>
</div>
